import svgUrl from "ni:svgr;kpOo2vxfRNLQW3kI7FA7ZNFF8M8FeObxQW-1vFxvDS4";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const StandardizeLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--clean--secondary)" fillRule="evenodd" d="M10 10H8a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-2h-8a4 4 0 0 1-4-4v-8Z" clipRule="evenodd" /><path fill="var(--tbl--colors--icons--clean--primary)" fillRule="evenodd" d="M14 4a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H14Zm0 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-3v7a1 1 0 1 1-2 0v-7h-3a1 1 0 0 1-1-1Z" clipRule="evenodd" /></svg>;
const Memo = memo(StandardizeLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "StandardizeLIcon";
}